export default __webpack_public_path__ + "static/media/24.33268796.png";